import { create } from 'zustand';

interface ExpandedStateStore {
  isExpanded: boolean;
  setIsExpanded: (halfOpen: boolean) => void;
  isExpandAnimationComplete: boolean;
  setIsExpandAnimationComplete: (isExpandAnimationComplete: boolean) => void;
}

const defaultExpandedState = {
  isExpanded: false,
  isExpandAnimationComplete: false,
};

export const useExpandedStateStore = create<ExpandedStateStore>((set) => ({
  ...defaultExpandedState,
  setIsExpanded: (isExpanded: boolean) => set({ isExpanded, isExpandAnimationComplete: false }),
  setIsExpandAnimationComplete: (isExpandAnimationComplete: boolean) => set({ isExpandAnimationComplete }),
}));
